import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContactDetailsComponent } from '../../contact-details/contact-details.component';
import { AutoFocusFirstInputDirective } from '../../../../shared/directives/auto-focus-first-input.directive';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AddressComponent } from '../../../../shared/components/address/address.component';
import { EnrollmentAddressComponent } from '../enrollment-address/enrollment-address.component';

@Component({
  selector: 'ppl-enrollment-contact-details',
  standalone: true,
  imports: [
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzGridModule,
    NzCardModule,
    NzSwitchModule,
    NzToolTipModule,
    AddressComponent,
    NzDividerModule,
    NzRadioModule,
    CommonModule,
    EnrollmentAddressComponent,
    AutoFocusFirstInputDirective,
  ],
  templateUrl: './enrollment-contact-details.component.html',
  styleUrl: './enrollment-contact-details.component.css',
})
export class EnrollmentContactDetailsComponent
  extends ContactDetailsComponent
  implements OnChanges {
  @Input() updatedFormValue: FormGroup['value'] | null;

  get contactMethodLabel(): string {
    return this.isEmployerAssociation
      ? 'Please supply your telephone number and at least one other contact method:'
      : 'Please provide a value for at least one of the following contact methods:';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['updatedFormValue'] &&
      changes['updatedFormValue'].currentValue &&
      this.updatedFormValue
    ) {
      this.contactForm.markAsDirty();
      this.contactForm.patchValue(this.updatedFormValue);
    }

    const contactDetailsChange = changes['contactDetailsData'];
    const taskManagerChange = changes['isEmployerTaskManagerSelf'];

    if ((contactDetailsChange || taskManagerChange) && this.flow === 'employer') {
      const isSelf = this.isEmployerTaskManagerSelf === 'SELF';
      if (this.contactDetailsData) {
        this.contactForm.patchValue(this.contactDetailsData);
      }
      this.validationErrors = {};
      this.formReadonly = isSelf;
      if (isSelf && !this.referralDataService.getAssociationsEditable()) {
        this.contactForm.get('altPhone')?.enable({ emitEvent: false });
      }

      const preferredMethods = this.contactForm.get('preferredMethod')?.value || [];
      if (isSelf) {
        if (!preferredMethods.includes('altPhone')) {
          preferredMethods.push('altPhone');
          this.contactForm.get('preferredMethod')?.setValue(preferredMethods);
        }
      } else {
        const index = preferredMethods.indexOf('altPhone');
        if (index > -1) {
          preferredMethods.splice(index, 1);
          this.contactForm.get('preferredMethod')?.setValue(preferredMethods);
        }
      }
    }
  }
}
